module.exports = __webpack_public_path__ + "static/media/trophy.a07aca7a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/teachers/noticeboard/trophy.svg
// module id = 570
// module chunks = 0